/**
 * Hero
 */

const hero_x = hero => {

  hero.querySelectorAll('.x-symbol').forEach(x => {
    hero.classList.add('is-ready');
    morph_on_scroll(x);
  });

}

const hero_init = hero => {

  if (!hero) {
    return;
  }

  if (!hero.querySelector('.x-symbol')) {
    return;
  }

  // not an image
  if (!hero.classList.contains('hero--type-image')) {
    hero_x(hero);
    return;
  }

  const image = hero.querySelector('.hero__media__image .image');
  if (image) {
    let prev_class = image.classList.contains('image--ready');

    // image loaded from cache
    if (prev_class) {
      hero_x(hero);
      return;
    }

    const hero_observer = new MutationObserver((mutations) => {
      mutations.forEach(mutation => {
        if (mutation.attributeName === 'class') {
          let current_class = mutation.target.classList.contains('image--ready');

          if (prev_class !== current_class) {
            prev_class = current_class;
            
            // image loaded
            if (current_class) {
              hero_x(hero);
              hero_observer.disconnect();
              return;
            }
          }
        }
      });
    });

    hero_observer.observe(image, { attributes: true });
  }

}

hero_init(document.querySelector('.hero'));
